import { createApiActions } from '@tabeeb/shared/utils/actions'
import { createAction } from 'redux-actions'

export const runUtilityInfrastructureAnalysis = createApiActions('RUN_UTILITY_INFRASTRUCTURE_ANALYSIS')
export const getPolesUniqueAiObjects = createApiActions('GET_POLES_UNIQUE_AI_OBJECTS')
export const setUniqueAiObjectsDialogState = createAction('SET_UNIQUE_AI_OBJECTS_DIALOG_STATE')
